import { useLang } from 'hooks/lang';

import { Row, Collapse, Checkbox, Input, Label } from 'components/Blocks';
import { DecimalInput } from 'components/Inputs';

import { FormControlDispatchAction } from 'hooks';

import { invoiceCountriesConfig } from 'utils/countries';
import { getID } from 'utils/id';

import { InvoiceCreationProps } from './types';
import { PercentIcon } from 'components/Icons';

interface PercentageProps {
  children?: never;
  country: string;
  state: InvoiceCreationProps;
  dispatch: FormControlDispatchAction<InvoiceCreationProps>;
}

export function ExtraPercentage({ state, dispatch, country }: PercentageProps): JSX.Element {
  const { t } = useLang();

  const { percentageConfig } = invoiceCountriesConfig[country];

  const { name, value } = percentageConfig;

  const handlePercentageToggle = (): void => {
    dispatch({
      additionalPercentage: ({ additionalPercentage }) =>
        additionalPercentage ? undefined : { value: value ?? '0.00', name: name ?? '' },
    });
  };

  const hasPercentage = !!state.additionalPercentage;

  return (
    <Row justifyContent="space-between" className="phone:flex-col">
      <Row gap="2">
        <Checkbox
          checked={hasPercentage}
          onChangeDirect={handlePercentageToggle}
          disabled={percentageConfig.required}
          id="addPercentage"
        />

        <Label htmlFor="addPercentage">{t('add-extra-percentage')}</Label>
      </Row>

      <Collapse expanded={hasPercentage}>
        <Row gap="2">
          <Input
            value={state.additionalPercentage?.name}
            name="additionalPercentageName"
            placeholder={t('increase-name') as string}
            disabled={!!name}
            className="w-36"
            onChange={
              name
                ? undefined
                : ({ target: { value } }) =>
                    dispatch({
                      additionalPercentage: ({ additionalPercentage }) => ({
                        ...(additionalPercentage as Exclude<
                          InvoiceCreationProps['additionalPercentage'],
                          undefined
                        >),
                        name: value,
                      }),
                    })
            }
          />

          <DecimalInput
            disabled={!!value}
            name={`additionalPercentage-${getID()}`}
            value={state.additionalPercentage?.value || ''}
            className="w-16"
            onChange={
              value
                ? undefined
                : ({ target: { value } }) =>
                    dispatch({
                      additionalPercentage: ({ additionalPercentage }) => ({
                        ...(additionalPercentage as Exclude<
                          InvoiceCreationProps['additionalPercentage'],
                          undefined
                        >),
                        value,
                      }),
                    })
            }
          />

          <PercentIcon />
        </Row>
      </Collapse>
    </Row>
  );
}
